/**
 * Loads the price list (Admin › Catalog › Analysis prices) once the app runs
 * in the browser, and again when the signed-in account changes, so its
 * discounts show. Renders nothing; see src/lib/analysisPrices.ts.
 */
import { useEffect } from "react";
import { useUserAccount } from "@/hooks/useUserAccount";
import { loadAnalysisPrices } from "@/lib/analysisPrices";

export default function AnalysisPricesLoader() {
  const { accountId } = useUserAccount();
  useEffect(() => {
    void loadAnalysisPrices(accountId ?? null);
  }, [accountId]);
  return null;
}
